// Środowisko DEV (domyślne dla `ng build` / `ng serve` -> deploy.bat -> s3://sidly-health-dev.com).
// UWAGA: katalog src/environments jest w .gitignore, więc ten plik NIE jest w repo —
// po świeżym klonie/checkoucie trzeba go odtworzyć, inaczej build pada na
// "Can't resolve './environments/environment'".
// Wartości zgodne z bundlem wystawionym na https://sidly-health-dev.com
export const environment = {
    production: false,
    avatar_url: 'https://api.sidly-platform-dev.com',
    api_url: 'https://api.sidly-platform-dev.com/api',
    socket_url: 'https://api.sidly-platform-dev.com'
};

// Lokalne API (odkomentuj w razie pracy na localhost):
// export const environment = {
//     production: false,
//     avatar_url: 'http://127.0.0.1:8000',
//     api_url: 'http://127.0.0.1:8000/api',
//     socket_url: 'http://127.0.0.1:3130'
// };
